// extracted by mini-css-extract-plugin
module.exports = {"button":"booking-flow-primary-button_button___SLN9","footnote":"booking-flow-primary-button_footnote__3-l6z"};